import React from "react";
import EventsOrganises from "../components/EventsOrganises";
import Testimonials from "../components/Testimonials";

export default function PortfolioPage() {
  return (
    <div>
      <EventsOrganises />
      <Testimonials />
    </div>
  );
}
